import styled from "styled-components";

export type TStatusIndicatorProps = {
  status: "orange" | "green" | "blue" | "red";
  className?: string;
};

const Container = styled.div<{ status: TStatusIndicatorProps["status"] }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${(props) => {
    switch (props.status) {
      case "orange":
        return "var(--color-aux-warning-100)";
      case "green":
        return "var(--color-aux-success-100)";
      case "blue":
        return "var(--color-blue-100)";
      case "red":
        return "var(--color-aux-danger-100)";
    }
  }};
`;

const Content = styled.div<{ status: TStatusIndicatorProps["status"] }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => {
    switch (props.status) {
      case "orange":
        return "var(--color-aux-warning-700)";
      case "green":
        return "var(--color-aux-success-700)";
      case "blue":
        return "var(--color-main-blue)";
      case "red":
        return "var(--color-aux-danger-700)";
    }
  }};
`;

const StatusIndicator: React.FC<TStatusIndicatorProps> = ({
  status,
  className,
}) => {
  return (
    <Container status={status} className={className}>
      <Content status={status} />
    </Container>
  );
};

export default StatusIndicator;
